import FfnManagement from './ffn-management-component';
import FfnManagementService from './ffn-management-service';
import './ffn-management.scss';
import FfnManagementNumberValidator from './ffn-management-number-validator';

const MODULE_NAME = 'travellers.ffn-management';
const module = angular.module(MODULE_NAME, [])
    .directive(FfnManagement.DIRECTIVE_NAME, FfnManagement)
    .service('ffnManagementService', FfnManagementService)
    .directive(FfnManagementNumberValidator.DIRECTIVE_NAME, FfnManagementNumberValidator);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/adult/ffn-management/ffn-management-module.js